(ns practitest.dev.attachments-story
  (:require
   [practitest.dev.utils :refer [debug-output]]
   [practitest.frontend.components.attachments :as attachments]
   [reagent.core :as reagent]))

(defonce state
  (reagent/atom
   {:options {:layout "cards"
              :permissions {:can-upload? true
                            :can-preview? true
                            :can-download? true
                            :can-rename? true
                            :can-delete? false
                            :can-copy-link? true}}
    :notifications {}
    :data    [{:id         1
               :name       "Attachment very very long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}
              {:id         2
               :name       "Attachment long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}
              {:id         3
               :name       "Attachment long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}
              {:id         4
               :name       "Attachment long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}
              {:id         5
               :name       "Attachment long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}
              {:id         6
               :name       "Attachment long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}
              {:id         7
               :name       "Attachment long name example"
               :size       (* 800 1024)
               :created-at #inst "2023-05-25T23:00"
               :author     {:id           1
                            :display-name "Kenny Lane"}
               :type       "image/jpeg"
               :url        "https://picsum.photos/400/300"}]}))

(defn radio-button [{:keys [name label checked? disabled? value on-change]}]
  [:div.form-check.form-check-inline
   [:input.form-check-input
    {:type      "radio"
     :name      name
     :value     value
     :checked   checked?
     :disabled  disabled?
     :on-change on-change}]
   [:label.form-check-label label]])

(defn checkbox [{:keys [label checked? on-change]}]
  [:div.form-check
   [:input.form-check-input
    {:type      "checkbox"
     :checked   checked?
     :on-change on-change}]
   [:label.form-check-label label]])

(defn layout-selector [state]
  (letfn [(mk-handler [path]
            (fn [e]
              (swap! state assoc-in path (-> e .-target .-value))))
          (checked? [path value]
            (= value (get-in @state path)))]
    [:div.col.mb-3
     [:label.form-label.pe-3 "Layout:"]
     (into [:<>]
           (for [[value label] [["cards" "cards"]
                                ["table" "table"]
                                ["list" "list"]]]
             [radio-button {:name "attachments-layout"
                            :label label
                            :value value
                            :checked? (checked? [:options :layout] value)
                            :on-change (mk-handler [:options :layout])}]))]))

(defn permissions-options [state]
  (letfn [(mk-handler [path]
            (fn [e]
              (let [checked? (-> e .-target .-checked)]
                (js/console.log "permissions-options" path checked?)
                (swap! state assoc-in path checked?))))
          (checked? [path]
            (boolean (get-in @state path)))]
    [:div.col.mb-3
     [:label.form-label.pe-3 "Permissions:"]
     (into [:<>]
           (for [[option label] [[:can-upload? "Can Upload?"]
                                 [:can-preview? "Can Preview?"]
                                 [:can-download? "Can Download"]
                                 [:can-rename? "Can Rename?"]
                                 [:can-delete? "Can Delete?"]
                                 [:can-copy-link? "Can Copy Link?"]]
                 :let           [path [:options :permissions option]]]
             [checkbox {:label     label
                        :checked?  (checked? path)
                        :on-change (mk-handler path)}]))]))

(defn fake-upload [file]
  (js/console.log "fake-upload" file)
  (let [filename (.-name file)
        filesize (.-size file)
        filetype (.-type file)
        delayed-upload (fn [item]
                         (let [item (assoc item :id (random-uuid))]
                           (js/setTimeout
                            (fn []
                              (swap! state
                                     (fn [state]
                                       (-> state
                                           (update :data conj item)
                                           (update-in [:notifications :uploading] dec)
                                           (update-in [:notifications :uploaded] (fnil inc 0))))))
                            3000)))]
    (if (attachments/image? filetype)
      (let [reader (js/FileReader.)]
        (.addEventListener reader "load"
                           (fn []
                             (delayed-upload {:name filename
                                              :size filesize
                                              :type filetype
                                              :created-at nil
                                              :src (.-result reader)})))
        (.readAsDataURL reader file))
      (delayed-upload {:name filename
                       :size filesize
                       :type filetype
                       :created-at nil}))
    (swap! state update-in [:notifications :uploading]
           (fnil inc 0))))

(defn fake-delete [{:keys [id] :as attachment}]
  (tap> [id (:id attachment) (type attachment) attachment (:data @state)])
  ;; TODO: notifications
  (swap! state update :data
         (fn [data]
           (vec
            (remove #(= id (:id %)) data)))))

(defn fake-rename [attachment new-name]
  (swap! state update :data
         (fn [data]
           (mapv (fn [item]
                   (if (= (:id attachment) (:id item))
                     (assoc item :name new-name)
                     item))
                 data))))

(defn fake-download [item]
  (js/console.log "on-download" item))

(defn fake-clear-notifications []
  (swap! state assoc :notifications {}))

(defn fake-cancel-uploads []
  (js/console.log "on-cancel-uploads"))

(defn notifications-simulation [state]
  (letfn [(simulate-upload [k]
            (swap! state update-in [:notifications :uploading]
                   (fnil inc 0))
            (js/setTimeout
             (fn []
               (swap! state update :notifications
                      (fn [notifications]
                        (-> notifications
                            (update :uploading dec)
                            (update k (fnil inc 0))))))
             3000))]
    [:div.col.mb-3
     {:style {:display "flex"
              :flex-direction "column"
              :align-items "center"
              :justify-content "center"}}
     [:button
      {:on-click (fn [_e]
                   (simulate-upload :uploaded))}
      "SIMULATE UPLOAD"]
     [:button
      {:on-click (fn [_e]
                   (simulate-upload :failed))}
      "SIMULATE FAILED UPLOAD"]
     [:button
      {:on-click (fn [_e]
                   (swap! state assoc :notifications {}))}
      "CLEAR NOTIFICATIONS"]]))

(defn ^{:title "Attachments"} attachments-view []
  [:div.container
   [:div.row
    [:h1 "Configuration"]
    [layout-selector state]
    [permissions-options state]
    [notifications-simulation state]]
   [:div.row {:style {:height "400px" :max-height "400px" :overflow "auto" }}
    [attachments/attachments-view
     {:options     (reagent/cursor state [:options])
      :attachments (reagent/cursor state [:data])
      :notifications (reagent/cursor state [:notifications])
      :actions {:on-upload fake-upload
                :on-delete fake-delete
                :on-rename fake-rename
                :on-download fake-download
                :on-clear-notifications fake-clear-notifications
                :on-cancel-uploads fake-cancel-uploads}}]]
   [:div.row
    [:div.col
     [:div.card
      [:div.card-header "state"]
      [:div.card-body
       [debug-output @state]]]]]])
